import { useParams } from 'react-router-dom'
import { SnapshotsList } from '../features/snapshots/SnapshotsList'

export default function SnapshotsListPage() {
  const { projectId, reportId } = useParams<{ projectId: string; reportId: string }>()

  return (
    <div className="flex h-full min-h-0 flex-col bg-light-body px-6 py-6">
      <h1 className="mb-4 text-lg font-semibold text-[#1B2559]">Snapshots</h1>
      <SnapshotsList clientId={Number(projectId)} reportId={Number(reportId)} />
    </div>
  )
}
